/**
 * @fileoverview GET handler for the "/engagement/audience_sync/:platform/ad_accounts/:ad_account_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAudienceSyncPlatformAdAccountsAdAccountId } from "./constants";
import type { EngagementAudienceSyncPlatformAdAccountsAdAccountIdResult } from "./types";

export const getEngagementAudienceSyncPlatformAdAccountsAdAccountId = reactQueryFetcherAdapter(
  engagementAudienceSyncPlatformAdAccountsAdAccountId,
  (
    signal: AbortSignal,
    platform: string,
    adAccountId: string
  ): Promise<EngagementAudienceSyncPlatformAdAccountsAdAccountIdResult> => {
    return fetch(
      `/engagement/audience_sync/${platform}/ad_accounts/${encodeURIComponent(adAccountId)}`,
      "GET",
      {},
      { signal },
      { propagateFetchRequestError: false }
    );
  }
);
